module.exports = [
  require('./kruthik_adult'),
  require('./kruthik_hive_lord'),
  require('./kruthik_young'),
]
